module.exports = __webpack_public_path__ + "static/media/4_AllInOne.af1996a1.png";